document.addEventListener('DOMContentLoaded', initImageLightbox);

function initImageLightbox() {
  const modal = document.querySelector('[data-image-lightbox-modal]');
  if (!modal) return;

  const imgEl = modal.querySelector('[data-image-lightbox-image]');
  const captionEl = modal.querySelector('[data-image-lightbox-caption]');
  const prevBtn = modal.querySelector('[data-image-lightbox-prev]');
  const nextBtn = modal.querySelector('[data-image-lightbox-next]');
  const closeEls = modal.querySelectorAll('[data-image-lightbox-close]');

  let images = [];
  let currentIndex = 0;
  let lastFocus = null;

  function parseImagesFromGroup(group) {
    if (!group) return [];
    const script = group.querySelector('[data-lightbox-images]');
    if (script) {
      try {
        return JSON.parse(script.textContent);
      } catch {
        return [];
      }
    }
    const raw = group.dataset.lightboxImages;
    if (!raw) return [];
    try {
      return JSON.parse(raw);
    } catch {
      return [];
    }
  }

  function openAt(index, groupImages) {
    images = groupImages;
    if (!images.length) return;

    currentIndex = Math.max(0, Math.min(index, images.length - 1));
    lastFocus = document.activeElement;

    render();
    modal.hidden = false;
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('image-lightbox-open');
    modal.querySelector('.image-lightbox__close')?.focus();
  }

  function close() {
    modal.hidden = true;
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('image-lightbox-open');
    if (imgEl) {
      imgEl.src = '';
      imgEl.alt = '';
    }
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  }

  function render() {
    const item = images[currentIndex];
    if (!item || !imgEl) return;

    imgEl.src = item.src;
    imgEl.alt = item.alt || '';

    const showNav = images.length > 1;
    if (prevBtn) prevBtn.hidden = !showNav;
    if (nextBtn) nextBtn.hidden = !showNav;

    if (captionEl) {
      if (item.alt) {
        captionEl.textContent = item.alt;
        captionEl.hidden = false;
      } else {
        captionEl.textContent = '';
        captionEl.hidden = true;
      }
    }
  }

  function step(delta) {
    if (images.length <= 1) return;
    currentIndex = (currentIndex + delta + images.length) % images.length;
    render();
  }

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-image-lightbox-trigger]');
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    const group = trigger.closest('[data-image-lightbox-group]');
    const groupImages = parseImagesFromGroup(group);
    const index = Number(trigger.dataset.imageIndex || 0);

    if (groupImages.length) {
      openAt(index, groupImages);
      return;
    }

    const src = trigger.dataset.lightboxSrc;
    if (!src) return;
    openAt(0, [{ src, alt: trigger.dataset.lightboxAlt || '' }]);
  });

  closeEls.forEach((el) => {
    el.addEventListener('click', close);
  });

  if (prevBtn) prevBtn.addEventListener('click', () => step(-1));
  if (nextBtn) nextBtn.addEventListener('click', () => step(1));

  document.addEventListener('keydown', (event) => {
    if (modal.hidden) return;
    if (event.key === 'Escape') close();
    if (event.key === 'ArrowLeft') step(-1);
    if (event.key === 'ArrowRight') step(1);
  });
}
